import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'was_the_grievance_mechanism_developed_through_social_dialogue_b'

export const dataPointDefinition = {
  retracedId: 'was_the_grievance_mechanism_developed_through_social_dialogue_b',
  name: 'Was the grievance mechanism developed through social dialogue between both male and female workers, unions and/or worker representative structures and managers?',
  description:
    'The intent of this question is to determine if the development of the grievance mechanism included input from all relevant stakeholders to help promote a fair and equitable grievance process',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'gr-1--3',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12940,
  sectionId: '2.2.10',
  impactArea: 'Social Dialogue, Grievance Mechanisms and Disputes',
  impactAreaId: 'COMPLAINT_AND_GRIEVANCE_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
